import { Select } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

function DepartmentSelect(props) {
  const { t } = useTranslation();
  const filterOption = () => {
    let index = props.deptNum + 1;
    let department = props.selectDepartMent;
    // let key = Object.keys(department)[props.deptNum];
    // let value = department[Object.keys(department)[props.deptNum]];
    // console.log(index, department, key, value);
    if (index > 1) {
      // let prevKey = Object.keys(department)[props.deptNum - 1];
      let prevValue = department[Object.keys(department)[props.deptNum - 1]];
      let tmp = props.department.filter((data) => data.PAR_CD === prevValue);
      if (tmp) {
        let result = [{ PAR_CD: "", DEPT_CD: "", DEPT_NM: t("LABEL.ALL") }];
        result.push(...tmp);
        return result;
      }
    } else {
      return props.department;
    }
  };

  return (
    <>
      {(props.deptNum + 1 > 1 &&
        !props.selectDepartMent[
        Object.keys(props.selectDepartMent)[props.deptNum - 1]
        ]) ||
        filterOption(props.department).length === 0 ? (
        <></>
      ) : (
        <Select
          size="large"
          placeholder="Select a place"
          defaultValue={t("LABEL.ALL")}
          loading={props.department === undefined}
          value={props.value}
          options={filterOption(props.department).map((dept) => ({
            label: dept.DEPT_NM,
            value: dept.DEPT_CD,
          }))}
          onSelect={(e) => {
            props.clickDepartment(props.deptNum + 1, e);
            // console.log(props.selectDepartMent);
          }}
        />
      )}
    </>
  );
}

export default DepartmentSelect;
